export class PcrEmpiConstants {
  public static ontarioEnterpriseIdentifierSystem = 'http://ehealthontario.ca/fhir/NamingSystem/id-pcr-eid';
  public static hssoQaSystem = 'http://ehealthontario.ca/fhir/NamingSystem/id-qa-hsso-def-source';
  public static ontarioCanadaPersonalHealthNumberSystem = 'https://fhir.infoway-inforoute.ca/NamingSystem/ca-on-patient-hcn';
  public static idQaHssoClientNumberSystem = 'http://ehealthontario.ca/fhir/NamingSystem/id-qa-hsso-client-number';
  public static idQaCentralLhin08ClientNumberSystem = 'http://ehealthontario.ca/fhir/NamingSystem/id-qa-central-lhin08-client-number';
  public static idQaHssoClientAlternateIdentifierSystem = 'http://ehealthontario.ca/fhir/NamingSystem/id-qa-hsso-client-alternate';
  public static idQaCentralLhin08ClientAlternateIdentifierSystem =
  'http://ehealthontario.ca/fhir/NamingSystem/id-qa-central-lhin08-client-alternate';
  public static enterpriseIdNamingSystem = 'http://ehealthontario.ca/fhir/NamingSystem/id-pcr-eid';
  public static r4_identifier_type_system = 'http://terminology.hl7.org/CodeSystem/v2-0203';
  public static allowedPatientIdentifierTypeCodes = ['JHN', 'MR', 'PI',  'PRI', 'EID'];
  public static maxReturnFromEmpi = 10;
}

export enum EmpiPatientIdentifierEnum {
  MRN = 'MR',
  HCN = 'JHN'
}
